import { render } from "./CertificatesSection.vue?vue&type=template&id=3bdb59a4"
import script from "./CertificatesSection.vue?vue&type=script&lang=js"
export * from "./CertificatesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__